<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-container fluid=""  v-if="!blnVerDetalle">
      <b-row class="divSubtitulo m-1 mb-3">
        <b-col cols="6" md="8">
          <div>
            <p class="textoSubtitulo">Historial de PTI´s</p>
          </div>
        </b-col>
        <b-col cols="6" md="4">
          <div>
            <p style="text-align:end" class="textoSubtitulo">PTI_Detalle</p>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <div class="contenedorTablaSinColor" style="border-radius: 10px;" v-if="!blnVerDetalle">
      <b-row >
        <b-col sm="12" md="12" lg="12">
          <b-table
              responsive
              id="TablaHistorialPti"
              thead-tr-class="columnasTablaSinColor"
              :items="datosTabla"
              :fields="fields"
              :per-page="registrosPorPagina"
              :current-page="paginaActual"
              selectable
              class="parrafos"
              hover>
            <template v-slot:cell(Acciones)="row">
              <b-button-group>
                <b-button v-if="row.item.estatus && $localStorageService.can('Detalle_PTI_ver')" variant="info" class=" mr-1 mt-1 marginbotones paddingbotones botonCentrado"
                          v-b-tooltip.hover
                          title="Ver Detalle"
                          @click="verDetallePti(row.item)"
                          responsive>
                  <em class="ojo_svg icon-boton" style=" position: relative; left: 0.5px;"></em>
                </b-button>

              </b-button-group>
            </template>
            <template v-slot:cell(fechaCreacion)="row">
              {{ row.item.fechaCreacion }}
            </template>
            <template v-slot:cell(fechaAceptacion)="row">
              {{ row.item.fechaAceptacion }}
            </template>
            <template v-slot:cell(fechaModificacion)="row">
              <span v-if="row.item.fechaModificacion !== null && row.item.fechaModificacion !== ''">
                {{ row.item.fechaModificacion }}
              </span>
              <span v-else>Sin Fecha</span>
            </template>
            <template v-slot:cell(estatus)="row">
              <div v-if="row.item.estatus">ACTIVO</div>
              <div v-else>INACTIVO</div>
            </template>
          </b-table>


          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="registrosPorPagina"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>
    </div>


    <div v-if="blnVerDetalle">
      <DetallePTIVisible :idPti="idPtiSeleccionado" :nombrePaciente="nombrePaciente" :fechaAceptacion="fechaAceptacion" :idPaciente="propidPaciente" :opcionAceptadaHistorial="opcionAceptadaHistorial"></DetallePTIVisible>
    </div>

  </div>
</template>

<script>
import DetallePTIVisible from "@/views/historialPTI/DetallePTIVisible";
export default {
  name: "historialPTI",
  components: {
    DetallePTIVisible
  },
  data:()=>{
    return{
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      loader: false,
      loaderAcciones: false,

      datosTabla:[],
      fields:[
        {key: "idPti", label:"ID PTI", sortable: true},
        {key: "fechaCreacion", label:"Fecha Creación", sortable: true},
        {key: "fechaAceptacion", label:"Fecha Aceptación", sortable: true},
        {key: "fechaModificacion", label:"Fecha Ult. Modificación", sortable: true},
        {key: "numeroTratamientos", label:"No. de Tratamientos Programados", sortable: true},
        {key: "estatus", label:"Estatus", sortable: true},
        "Acciones",
      ],

      pti:{
        idPti:null,
        fechaCreacion: null,
        fechaAceptacion: null,
        fechaModificacion: null,
        numeroTratamientos: null,
        estatus: null
      },


      registrosPorPagina: 10,
      paginaActual: 0,
      blnVerDetalle: false,
      idPtiSeleccionado: null,
      fechaAceptacion: null,
      opcionAceptadaHistorial: null
    }
  },
  props: {
    propidPaciente: Number,
    nombrePaciente: String,
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.obtener();
  },

  methods:{
    obtener() {
      this.loader = true;
      this.datosTabla = [];
      const parametros = {idPaciente: this.propidPaciente}
      this.$http.post(this.$api + 'pti/visible/obtener/historialPti', parametros).then(respuesta => {
            if (respuesta.data.data) {
              respuesta.data.data.forEach(it => {
                this.paginaActual=1;
                this.datosTabla.push(it);
              })
            }

          }
      ).finally(() => {
            this.loader = false;
          }
      )
    },
    verDetallePti(item){
      if (item.idEtapa === 94){
        this.$router.push({
          name: "SolicitudEdicion",
          params: {
            idPaciente: this.propidPaciente,
            idPti: item.idPti,
            idEtapa: item.idEtapa,
          },
        });
      }else {
        this.blnVerDetalle = true;
        this.idPtiSeleccionado = item.idPti;
        this.opcionAceptadaHistorial = item.opcionAceptadaHistorial;
        this.fechaAceptacion = item.fechaAceptacion;
      }

    }
  }
}
</script>

<style scoped>

.icon-boton {
  filter: brightness(0) invert(1);
  height: 20px;
  display: block;
}
.paddingbotones {
  padding: 5px;
}

.marginbotones{
  border-radius:20px;
}

.botonesAzulFuerte {
  border-radius: 10rem;
  color: #fff;
  background-color: var(--color-icono);
  border-color: var(--color-icono);
  margin-left: 5%;
}

.botonCentrado{
  padding-bottom: 4px;
  padding-top: 1px;
  padding-left: 2px;
  padding-right: 4px;
}
</style>
